import { FormField } from '@hilma/netina2all';

import { I18n } from '../types';

export const addCampaignDetailsClient: FormField<I18n>[] = [
	{
		description: i18n => i18n.at.tableTitles.name,
		id: 'name',
	},
	{
		description: i18n => i18n.at.campaignDate,
		id: 'campaignDate',
		inputType: 'date',
	},
	{
		description: i18n => i18n.at.source,
		id: 'source',
		ltr: true,
	},
	{
		description: i18n => i18n.at.medium,
		id: 'medium',
		ltr: true,
	},
	{
		description: i18n => i18n.at.content,
		id: 'content',
		ltr: true,
	},
]